import moment from 'moment';

// Utility function to generate date range options

export type FilterOption = {
  label: string;
  startDate: Date;
  endDate: Date;
};

export const generateDateRangeOptions = (): FilterOption[] => [
  {
    label: 'All time',
    startDate: moment().subtract(2, 'years').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  {
    label: '7 days',
    startDate: moment().startOf('day').subtract(7, 'days').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  {
    label: '30 days',
    startDate: moment().subtract(30, 'days').startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  {
    label: '3 months',
    startDate: moment().subtract(3, 'months').startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  {
    label: '6 months',
    startDate: moment().subtract(6, 'months').startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  {
    label: '12 months',
    startDate: moment().subtract(12, 'months').startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  {
    label: 'This year',
    startDate: moment().startOf('year').toDate(),
    endDate: moment().endOf('year').toDate(),
  },
];
